import { Autocomplete, Box, Button, CircularProgress, TextField } from "@mui/material"
import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { generateExcel } from "../../../../api/apiCall";
import { useAuth } from "../../../../auth/auth";
import { toast } from "react-toastify";

const GenerateExcel = ({setOpen, clients, workerId, companyId}: any) => {
    const {state} = useAuth();
    const [loading, setLoading] = useState(false);
    const { register, handleSubmit, control } = useForm<any>({
        defaultValues: {
          userId: workerId,
          companyId: companyId,
          recipientEmail: "",
        },
    });

    const generateFatigueAndRiskExcel = async (data: any) => {
        try {
            setLoading(true);
            const response: any = await generateExcel(state.user?.token, workerId, data.companyId.id, data.recipientEmail);
            if(response?.status === 200) {
                setLoading(false);
                setOpen(false);
                toast.success(`Email sent successfully to ${data.companyId.companyName}`)
            }else {
                toast.error(response.message);
                setLoading(false);
                setOpen(false);
            }
            console.log(response,'res')
        } catch (error) {
            setLoading(false);
            console.error('Error generating Excel:', error);
        }
    };

    return (
        <Box display="grid" gridTemplateColumns={{ xs: "1fr", md: "1fr" }} gap={3}>
            <Controller
                name="companyId"
                control={control}
                render={({ field }) => (
                    <Autocomplete
                        options={clients}
                        getOptionLabel={(option: any) => option.companyName || ""}
                        isOptionEqualToValue={(option: any, value: any) =>
                            option.companyName === value?.companyName
                        }
                        value={field.value || null}
                        onChange={(_, value) => field.onChange(value)}
                        clearOnEscape
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Client"
                                size="small"
                            />
                        )}
                    />
                )}
            />
            <TextField
                label={"Email"}
                type="text"
                size="small"
                {...register("recipientEmail")}
            />
            <div className="center-button-div">
                <Button
                    variant="contained"
                    disabled={loading}
                    sx={{boxShadow: 'none', mb: 2, width: 180}}
                    onClick={handleSubmit(generateFatigueAndRiskExcel)}
                >
                    {loading ? (
                        <CircularProgress size={25} style={{color: 'white'}} />
                    ) : "Generate Excel"}
                </Button>
            </div>
        </Box>
    );
};

export default GenerateExcel;
